import { __awaiter } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { axiosClient } from '@as-react/common-utils';
import { Box, LinkButton, Prose, Stack, TextAlpha } from '@yonderland/andes-react';
import { useEffect, useState } from 'react';
import BrowserUtil from '../../../util/BrowserUtil';
import { COOKIE_TABS } from './CookieMessage';
export const CookieDefaultMessage = ({ title, description, privacyLinkText, privacyLinkHref, partnersLinkHref, partnersLinkText, setActiveTab, setContentData, }) => {
    const [isBrowserInstagram, setIsBrowserInstagram] = useState(false);
    useEffect(() => {
        setIsBrowserInstagram(BrowserUtil.isBrowserInstagram());
    }, []);
    const showCookieContent = (url) => (e) => __awaiter(void 0, void 0, void 0, function* () {
        e.preventDefault();
        const axiosConfig = {
            method: 'GET',
            url,
        };
        try {
            const res = yield axiosClient.request(axiosConfig);
            setContentData(res.data);
            setActiveTab(COOKIE_TABS.CONTENT);
        }
        catch (_a) { }
    });
    return (_jsx(Box, { paddingBlockEnd: {
            base: '30',
            md: isBrowserInstagram ? '20' : '2',
        }, children: _jsxs(Stack, { direction: "col", gap: "4", children: [_jsx(TextAlpha, { variant: "headingS", children: title }), _jsxs(Stack, { direction: "col", gap: "6", children: [_jsx(Prose, { html: description }), _jsxs(Stack, { gap: "6", children: [_jsx(LinkButton, { tabIndex: 0, testId: "cookie-privacy-link", variant: "secondary", onClick: showCookieContent(privacyLinkHref), children: privacyLinkText }), partnersLinkHref && partnersLinkText && (_jsx(LinkButton, { tabIndex: 0, testId: "cookie-partners-link", variant: "secondary", onClick: showCookieContent(partnersLinkHref), children: partnersLinkText }))] })] })] }) }));
};
